import React, { useState } from "react";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import styled from "styled-components";
import { CgClose } from "react-icons/cg";
import Button from "../../../Button/Button";
import {
  useUpdateBrand,
  useGetProductList1,
} from "../../../../hooks/useContent";
import {
  RefreshTableBrand,
  ContentUnitModal,
} from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import {
  RowElement,
  RowLayoutStyle,
} from "../../../ContentUnit/Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { errorMessage } from "../../../../utils/message";
import { useGetCategory } from "../../../../hooks/useCrm";

function EditBrand({ show, handleClose }) {
  const {
    mutateAsync: updateProperty,
    isLoading: reqLoading,
    isError: reqError,
  } = useUpdateBrand();
  const [refreshEffect, setRefreshEffect] = useRecoilState(RefreshTableBrand);
  const [updateState, setUpdateState] = useRecoilState(ContentUnitModal);
  const { data: cat } = useGetCategory();
  const categories = cat?.data?.categories;
  const categoriesOptions = categories?.map((cat) => {
    return {
      value: cat.IdCategories,
      label: cat.NameCategories,
    };
  });

  const [initialValues, setValueForm] = useState({
    name: updateState.updateBrand.value.NameBrands
      ? updateState.updateBrand.value?.NameBrands
      : "",
    en_name: updateState.updateBrand.value.NameEnglishBrands
      ? updateState.updateBrand.value?.NameEnglishBrands
      : "",
    ar_name: updateState.updateBrand.value.NameLanguageBrands
      ? updateState.updateBrand.value?.NameLanguageBrands
      : "",
    logo: "",
    brand_id: updateState.updateBrand.value.IdBrands
      ? updateState.updateBrand.value.IdBrands
      : "",
    category_id: updateState.updateBrand.value.IdCategories
      ? updateState.updateBrand.value.IdCategories
      : 0,
  });

  const { data: listProduct, isLoading: loadingCategorty } =
    useGetProductList1("");

  const initialListProduct = listProduct?.data?.categories?.map((item) => ({
    label: item?.NameCategories,
    value: item?.IdCategories,
  }));

  const isValidImg = (event) => {
    let isValid = true;

    const file = event.target.files[0];
    if (file.type !== "image/svg+xml" || file.size > 0.8e6) {
      file.size > 0.8e6
        ? errorMessage("فایل انتخاب شده بیشتر از 800 مگ است")
        : errorMessage("فایل انتخاب شده صحیح نیست");
      isValid = false;
      event.target.value = "";
    }
    return isValid;
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    if (e.target?.type === "file") {
      const file = e.target.files[0];
      if (isValidImg(e)) {
        setValueForm({ ...initialValues, [name]: file });
      } else setValueForm({ ...initialValues, [name]: "" });
      return 3;
    }

    setValueForm({
      ...initialValues,
      [name]: value,
    });
  };

  const validateForm = () => {
    if (initialValues.name.length < 1) {
      errorMessage("لطفا نام فارسی برند را وارد کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const formData = new FormData();
      formData.append("name", initialValues.name);
      formData.append("en_name", initialValues.en_name);
      formData.append("ar_name", initialValues.ar_name);
      formData.append("logo", initialValues.logo);
      formData.append("brand_id", initialValues.brand_id);
      formData.append("category_id", initialValues.category_id);

      updateProperty(formData).then((res) => {
        setRefreshEffect(!refreshEffect);
        handleClose();
      });
    }
  };

  const getCategoryId = () => {
    const result = initialListProduct?.filter(
      (opt) => opt?.value === initialValues.category_id
    );

    if (result.length > 0) return result[0]?.label;

    return "انتخاب کنید";
  };

  return (
    <BootstrapModal
      show={show}
      handleClose={handleClose}
      modaltitle={"ویرایش برند "}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <UpdateCategoryStyle>
        <RowColumn>
          <InputField1
            type="text"
            name="name"
            label="نام فارسی"
            onChange={handleChange}
            value={initialValues?.name}
            placeholder="نام فارسی برند.."
            maxLenght="50"
          />

          <InputField1
            type="text"
            name="en_name"
            label="نام انگلیسی"
            onChange={handleChange}
            value={initialValues?.en_name}
            placeholder="نام انگلیسی برند ..."
            maxLenght="50"
          />

          <InputField1
            type="text"
            name="ar_name"
            label="نام عربی"
            onChange={handleChange}
            value={initialValues?.ar_name}
            placeholder="نام برند عربی ..."
            maxLenght="50"
          />
        </RowColumn>
        <div className="w-100">
          <SimpleSelect1
            res={categoriesOptions}
            label="دسته بندی"
            onChange={(e) =>
              setValueForm({ ...initialValues, category_id: e.value })
            }
          />
        </div>
        <InputField1
          type="file"
          name="logo"
          label="لوگو"
          onChange={handleChange}
          placeholder="لوگو"
          maxLenght="50"
        />
        <div>
          <Button
            bgColor={"#4c78a9"}
            small={"100px"}
            className="mt-1"
            onclick={(e) => {
              !reqLoading && handleSubmit();
            }}
            color="#fff"
          >
            {reqLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <Typography size={"15px"} primary={"#fff"}>
                ویرایش
              </Typography>
            )}
          </Button>
          <Button
            className={"mt-2"}
            style={{ marginRight: "10px" }}
            color={"#fff"}
            bgColor={"#f1416c"}
            small={"100px"}
            onclick={handleClose}
          >
            <Typography size={"15px"} primary={"#fff"}>
              انصراف
            </Typography>
          </Button>
        </div>
      </UpdateCategoryStyle>
    </BootstrapModal>
  );
}

const UpdateCategoryStyle = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

const RowColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export default EditBrand;
